@if(qtyCompare()){
<button mat-flat-button class="btn-compare" [ngClass]="themeClass()" (click)="handleClickCompare()">
  <p class="font-size-14 font-weight-medium">เปรียบเทียบยาง</p>
  <p class="font-size-24 font-weight-bold">{{ '(' + qtyCompare() + ')' }}</p>
</button>
}
